///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createReducer, on } from '@ngrx/store';
import { UsersListState, initialState } from './users-list.state';
import {
    getUsersPage,
    setCurrentAccount,
    setUsersPage,
    setShowEditButton,
    getUserActivityEventsPage,
    setUserActivityEventsPage,
    getUserActivityEventTypes,
    setUserActivityEventTypes
} from './users-list.actions';

export const reducer = createReducer(
    initialState,

    on(getUsersPage, (state: UsersListState): UsersListState => {
        return {
            ...state,
            isLoading: true
        };
    }),

    on(setUsersPage, (state: UsersListState, action): UsersListState => {
        return {
            ...state,
            isLoading: false,
            usersPage: action.usersPage,
            usersList: action.usersPage.content,
            totalItems: action.usersPage.page.totalElements,
            pageNumber: action.usersPage.page.number + 1,
            totalPages: action.usersPage.page.totalPages
        };
    }),

    on(setShowEditButton, (state: UsersListState, action): UsersListState => {
        return {
            ...state,
            showEditButton: action.showEditButton
        };
    }),

    on(setCurrentAccount, (state: UsersListState, action): UsersListState => {
        return {
            ...state,
            currentAccount: action.currentAccount
        };
    }),

    on(getUserActivityEventsPage, (state: UsersListState): UsersListState => {
        return {
            ...state,
            isLoading: true
        };
    }),

    on(setUserActivityEventsPage, (state: UsersListState, action): UsersListState => {
        return {
            ...state,
            isLoading: false,
            selectedUserActivityEventsPage: action.userEventsPage
        };
    }),

    on(getUserActivityEventTypes, (state: UsersListState): UsersListState => {
        return {
            ...state,
            isLoading: true
        };
    }),

    on(setUserActivityEventTypes, (state: UsersListState, action): UsersListState => {
        return {
            ...state,
            isLoading: false,
            userEventTypes: action.userEventTypes
        };
    })
);
